import React from 'react';
import { Box, useTheme } from '@mui/material';

/**
 * A reusable card component for displaying static content without hover effects
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements to render inside the card
 * @param {Object} props.sx - Additional sx styling to apply
 * @returns {React.ReactElement} The StaticCard component
 */
const StaticCard = ({ children, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: theme.palette.background.cardStatic,
        boxShadow: theme.palette.lightBoxShadow,
        position: 'relative',
        ...props.sx
      }}
    >
      {children}
    </Box>
  );
};

export default StaticCard; 